import { gql } from '@/store/helpers/axios.js'

export default {
  async GET_PERMISSIONS ({ state, commit }, applicationId) {
    const { isDraft } = state
    let query = ''
    let variables = ''

    if (isDraft) {
      query = `query antragDraftPermissions ($antragDraftId: Int!) {
        antragDraftPermissions (antragDraftId: $antragDraftId) {
          nodes {
            id
            fullname
            email
            username
            invitedDate
            inviteState
          }
        }
      }`

      variables = {
        antragDraftId: applicationId,
        order_by: {
          fullname: 'ASC'
        }
      }
    } else {
      query = `query gesuchPermissions ($gesuchId: Int!) {
        gesuchPermissions (gesuchId: $gesuchId) {
          nodes {
            id
            fullname
            email
            username
            invitedDate
            inviteState
          }
        }
      }`

      variables = {
        gesuchId: applicationId,
        order_by: {
          fullname: 'ASC'
        }
      }
    }

    const { data } = await gql({ query, variables })

    if (!data.errors) {
      if (isDraft) {
        commit('SET_PERMISSIONS', data.data.antragDraftPermissions.nodes)
      } else {
        commit('SET_PERMISSIONS', data.data.gesuchPermissions.nodes)
      }
    }

    return data
  },
  async GET_PERMISSIONS_SIGNATURE ({ state, commit }, applicationId) {
    const query = `query gesuchPermissionsSignature ($gesuchId: Int!) {
      gesuchPermissionsSignature (gesuchId: $gesuchId) {
        nodes {
          id
          fullname
          email
          username
          invitedDate
          inviteState
          inviteSignature
        }
      }
    }`

    const variables = {
      gesuchId: applicationId,
      order_by: {
        fullname: 'ASC'
      }
    }

    const { data } = await gql({ query, variables })

    if (!data.errors) {
      commit('SET_PERMISSIONS_SIGNATURE', data.data.gesuchPermissionsSignature.nodes)
    }

    return data
  },
  async CREATE_PERMISSION ({ state, commit }, { formData, applicationId }) {
    const { isDraft } = state
    let query = ''
    let variables = ''
    const { email } = formData

    if (isDraft) {
      query = `mutation antragDraftPermissionCreate ($input: AntragDraftPermissionCreateInput!) {
        antragDraftPermissionCreate (input: $input) {
          email
          invitedDate
          inviteState
        }
      }`

      variables = {
        input: {
          antragDraftId: applicationId,
          email
        }
      }
    } else {
      query = `mutation gesuchPermissionCreate ($input: GesuchPermissionsCreateInput!) {
        gesuchPermissionCreate (input: $input) {
          email
          invitedDate
          inviteState
        }
      }`

      variables = {
        input: {
          gesuchId: applicationId,
          email
        }
      }
    }

    const { data } = await gql({ query, variables })

    if (!data.errors) {
      let permission = {}

      if (isDraft) {
        permission = data.data.antragDraftPermissionCreate
        commit('SET_PERMISSION', permission)
      } else {
        permission = data.data.gesuchPermissionCreate
        commit('SET_PERMISSION', permission)
      }
    }

    return data
  },
  async CREATE_SIGNATURE_PERMISSION ({ state, commit }, { formData, applicationId }) {
    const query = `mutation gesuchSignaturePermissionCreate ($input: GesuchPermissionsCreateInput!) {
        gesuchSignaturePermissionCreate (input: $input) {
          email
          invitedDate
          inviteState,
          inviteSignature
        }
      }`

    const variables = {
      input: {
        gesuchId: applicationId,
        email: formData
      }
    }

    const { data } = await gql({ query, variables })

    if (!data.errors) {
      let permission = {}

      permission = data.data.gesuchSignaturePermissionCreate
      commit('SET_PERMISSION_SIGNATURE', permission)
    }

    return data
  },
  async DELETE_PERMISSION ({ state, commit }, permissionId) {
    const { isDraft } = state
    let query = ''

    if (isDraft) {
      query = `mutation antragDraftPermissionDelete ($permissionId: Int!) {
        antragDraftPermissionDelete (permissionId: $permissionId) {
          ok
         }
      }`
    } else {
      query = `mutation gesuchPermissionDelete ($permissionId: Int!) {
        gesuchPermissionDelete (permissionId: $permissionId) {
          ok
         }
      }`
    }

    const variables = {
      permissionId
    }

    const { data } = await gql({ query, variables })

    if (!data.errors) {
      commit('DELETE_PERMISSION', permissionId)
    }

    return data
  },
  async PERMISSION_INVITE_ACCEPT ({ state, commit }, inviteCode) {
    const { isDraft } = state
    let query = ''

    if (isDraft) {
      query = `mutation antragDraftPermissionInviteAccept ($inviteCode: String!) {
        antragDraftPermissionInviteAccept (inviteCode: $inviteCode) {
          ok
        }
      }`
    } else {
      query = `mutation gesuchPermissionInviteAccept ($inviteCode: String!) {
        gesuchPermissionInviteAccept (inviteCode: $inviteCode) {
          ok
          gesuchId
          inviteSignature
        }
      }`
    }

    const variables = {
      inviteCode
    }

    const { data } = await gql({ query, variables })
    commit('SET_INVITE_CODE', '')

    return data
  },
  async PERMISSION_INVITE_DENY ({ state, commit }, inviteCode) {
    const { isDraft } = state
    let query = ''

    if (isDraft) {
      query = `mutation antragDraftPermissionInviteDeny ($inviteCode: String!) {
        antragDraftPermissionInviteDeny(inviteCode: $inviteCode) {
          ok
        }
      }`
    } else {
      query = `mutation gesuchPermissionInviteDeny ($inviteCode: String!) {
        gesuchPermissionInviteDeny(inviteCode: $inviteCode) {
          ok
        }
      }`
    }

    const variables = {
      inviteCode
    }

    const { data } = await gql({ query, variables })

    if (!data.errors) {
      commit('SET_INVITE_CODE', '')
    }

    return data
  }
}
